export type PermissionLevel = 
    | 'NONE'
    | 'READ'
    | 'WRITE';

export const normalizePermission = (
    authVal: string,
): PermissionLevel => {
    switch (authVal) {
        case 'Y':
            return 'WRITE';
        case 'R':
            return 'READ';
        default:
            return 'NONE';
    }
}